﻿/**
* SSE 事件类型常量
*/

export const SSE_EVENTS = {
  MESSAGE_START: 'message_start',
  MESSAGE: 'message',
  MESSAGE_END: 'message_end',
  WORKFLOW_FINISHED: 'workflow_finished',
  ERROR: 'error',
} as const

export type SseEventType = typeof SSE_EVENTS[keyof typeof SSE_EVENTS]
